import React, {  useState, useEffect, useRef} from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL} from '../utils/common';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const LedgerReports = () => 
{           
            const [cName,setCName]=useState();
            const [rptDate,setRptDate]=useState();
            const [closingBalance,setClosingBalance]=useState(0);
            const [customerData, setCustomerData]= useState([]);   
            const fileType ="xlsx";
            const tableRef = useRef(null);
            const API_URL=aPIURL();
            const [custID,setCustID]= useState("0");                           
            const [post, setPost] = useState([]);
            
            useEffect(() => {
                 //set today date as default date starts
                var now = new Date();
                var month = (now.getMonth() + 1);               
                var day = now.getDate();
                if (month < 10) 
                month = "0" + month;
                if (day < 10) 
                day = "0" + day;
                var today = day + '-' + month + '-' + now.getFullYear();
                setRptDate(today);
                //set today date as default date ends
                const curls=API_URL+`GpsSaleCustomerList/`;     
                axios.post(curls).then(response => {        
                setCustomerData(response.data.data);                       
                }).catch(function(error) { console.log(error.message); });                                     
            }, []);              

const FillGrid=(ID)=>
{
        const curls=API_URL+`GetLedgerReport/${ID}`;   
        setPost([]);
        axios.get(curls).then(response => {                      
        setPost(response.data.data);
        setCName(response.data.data[0].customerName);
        setClosingBalance(response.data.data[0].closingBalance);   

     }).catch(function(error){console.log(error.message);});
}
const FilterGrid=()=>
  {
    if (custID === "0") 
        {
            toast.error('Please Select Customer.')
            setPost([]);      
            setClosingBalance(0);
            setCName('');
            return
        }
        else
        {
            setClosingBalance(0);          
            setCName('');              
            FillGrid(custID);
        }        
  }

const ChangeCustomerID = (e) => {
        setCustID(e.target.value);               
    }

  const exportStatus = e => {
     const value = e.target.value;
     FillGrid(value);
  }

  const exportToCSV=()=>
    {
       const newPost = post.map(({ tcr,tdr,tcBalance,closingBalance,customerName, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [ {wch:5}, {wch:10}, {wch:20},{wch:10},{wch:20},{wch:20} ];
       var wsrows = [ {hpx: 30} ];
       ws['!cols'] = wscols;
       ws['!rows']=wsrows;
      
       let Heading = [['S.NO.','DATE','REFERENCE','CR','DR','VOUCHER NO.']];
       const wb={Sheets:{Ledger:ws},SheetNames:["Ledger"]};
       XLSX.utils.sheet_add_aoa(ws, Heading);     
       const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
       const data= new Blob([excelBuffer],{type:fileType});
       FileSaver.saveAs(data,"AVTLedger"+".xlsx");
     }

const ResetList=()=>
{
      setPost([]);      
      setClosingBalance(0);
      setCName('');
      setCustID("0");      
}
const exportDownload = e => 
{  
  const value = e.target.value;   
  if(value==="Excel")
  {
        exportToCSV();   
  }
  if(value==="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}
const handlePrint = useReactToPrint({
    documentTitle: "UserLedger",
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    removeAfterPrint: true,
});
return (
<>   
<div className="top-bar clearfix">
<div className="row">
<div className="col-md-4"><h2> Ledger Report </h2></div>
<div className="col-md-8 text-right">   
<select onChange={exportDownload} className="btn btn-primary" name="Download" >
<option value={"Download"}>Download</option>    
<option value={"Excel"}>Excel</option>    
<option value={"PDF"}>PDF</option>                      
</select>
</div></div></div>    
<div className="container-fluid p-3">
<div class="card mb-3 shadow no-border border-0">
<div class="card-body">
<div class="row align-items-end">  
<div class="col-sm-2 col-lg-2" style={{textAlign:"center"}}>Customer Name<span style={{color:"red"}}>&nbsp;*</span></div>  
<div class="col-sm-4 col-lg-2">   <select className="form-control"  name="DCustomerID" value={custID} onChange={ChangeCustomerID} >
<option value={0}>------ Select Customer ------</option>
{customerData.map((e, key) => {
return <option key={key} value={e.accountID}>{e.customerName}</option>;
})}</select></div>
<div class="col-sm-4 col-lg-2">
<button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
<button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetList}>Reset
</button></div>
<div class="col-sm-3 col-lg-2"></div></div></div></div>
<div className="container-fluid p-3">
<div class="card mb-3 shadow no-border border-0">
<div ref={tableRef} style={{ padding:"25px"}} class="card-body">    
<div class="row align-items-end">  
<span style={{ textAlign:'center',fontSize:"18px" }}><b>Ledger Report</b> </span>
<span style={{ textAlign:'right' }}>DATE : { rptDate }</span>
<span style={{ textAlign:'left' }}><b> { cName }</b></span>          
<table id="example" class="table table-striped table-bordered table-hover" style={{width:"100%", marginTop:"20px"}}>
<thead>
    <tr>
    <th style={{ width:"5%", textAlign:"center"}}>S.No.</th>
    <th style={{width:"15%",textAlign:"center","cursor": "pointer"}}>DATE </th>
    <th style={{width:"15%",textAlign:"center","cursor": "pointer"}}>VOUCHER NO. </th>
    <th style={{width:"35%",textAlign:"center","cursor": "pointer"}}>REFERENCE </th>
    <th style={{width:"15%",textAlign:"center","cursor": "pointer"}}>CR </th>
    <th style={{width:"15%",textAlign:"center","cursor": "pointer"}}>DR </th>    
    </tr>
</thead>
<tbody>
{post.map((devdata) => {
return (
    <tr key={devdata.id}>
    <td style={{textAlign:"center"}}>{devdata.id}</td>
    <td style={{textAlign:"center"}}>{devdata.rDate}</td>
    <td style={{textAlign:"center"}}>{devdata.voucherNo}</td>
    <td style={{textAlign:"left"}}>{devdata.reference}</td>
    <td style={{textAlign:"right"}}>{devdata.cr}</td>
    <td style={{textAlign:"right"}}>{devdata.dr}</td>                  
    </tr>
); })}
</tbody></table>
<span style={{ textAlign:'right' }}><b> Total Balance : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ closingBalance }</b></span> 
</div></div></div></div></div>
<ToastContainer position="bottom-right" autoClose={4000} theme="light"/>       
</>
); }   
export default LedgerReports;
